module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 60
// module chunks = 0